<template>
  <div>
  </div>
</template>
<script>
  export default {
    name: 'Platform',
    data () {

      return {
      }
    },
    created () {
      let token=this.$route.query.token
      let kbtoken=this.$route.query.kbtoken
      let code=this.$route.query.code
      let areacode=this.$route.query.areacode
      let path=this.$route.query.path
      if(kbtoken){//直接登录
        this.xy.removeCookie('.XYTOKEN')
        this.xy.setCookie(kbtoken)
        this.$store.commit('common/setIsPlatform', true)
        if(path){
          this.$store.commit('common/setPlatformPath', path)
          this.$router.replace('/funclist')
        }else{
          this.$router.replace("/xyIndex");
        }
      }else{//认证登录
        this.xy.loading()
        this.xyapi.get(this.platform + '/api/TimeTable/OAuth',{
          code:code,
          areacode:areacode,
          token:token
        }).then(res => {
          this.xy.unloading()
          if (res.success) {
            this.xy.removeCookie('.XYTOKEN')
            this.$store.commit('common/setIsPlatform', true)
            if(path){
              this.$store.commit('common/setPlatformPath', path)
              this.$router.replace('/funclist')
            }else{
              this.$router.replace("/xyIndex");
            }
            this.xy.setCookie(res.data)
          }
        })
      }

    },
    mounted () {},
    methods: {

    }
  }
</script>
<style lang="less" scoped>

</style>
